module.exports = __webpack_public_path__ + "static/media/122.eb408e15.svg";